import LookupSelect from "./LookupSelect";

const LookupFilters = ({ selected, setfilters, filters }) => {
  const onClickHandler = (key, val) => {
    setfilters((prev) => ({ ...prev, [key]: val }));
  };
  return (
    <div className="absolute bottom-16 pt-4 left-0 border-t max-w-lg overflow-x-auto px-8 w-full">
      {selected === "Products" && (
        <div className="flex items-center">
          <LookupSelect
            onClick={() => onClickHandler("draft", "all")}
            selected={filters["status"]}
            title="Include Unapproved"
            active={filters["draft"] === "all" && true}
          />
          <LookupSelect
            onClick={() => onClickHandler("draft", "approved")}
            selected={filters["status"]}
            title="Approved Only"
            active={filters["draft"] === "approved" && true}
          />

          <LookupSelect
            onClick={() => onClickHandler("status", "active")}
            selected={filters["status"]}
            title="In Stock"
            active={filters["status"] === "active" && true}
          />
          <LookupSelect
            onClick={() => onClickHandler("status", "draft")}
            selected={filters["status"]}
            title="Out Of Stock"
            active={filters["status"] === "draft" && true}
          />
        </div>
      )}
    </div>
  );
};

export default LookupFilters;
